const catData = [
    {
        catName: "All",
        catIcon: "all.jpg",
        catLink: "/explore"
    },
    {
        catName: "Vegetables",
        catIcon: "vegitable.png",
        catLink: "/category/vegetables"
    },
    {
        catName: "Fruits",
        catIcon: "fruits.jpg",
        catLink: "/category/fruits"
    },
    {
        catName: "Kirana",
        catIcon: "kirana.png",
        catLink: "/category/kirana"
    },
    {
        catName: "Dry-Fruits",
        catIcon: "dry-fruit.jpg",
        catLink: "/category/dry-fruits"
    },
    {
        catName: "Dairy",
        catIcon: "dairy.jpg",
        catLink: "/category/dairy"
    },
    {
        catName: "Bakery",
        catIcon: "bakery.jpg",
        catLink: "/category/bakery"
    },
    // {
    //     catName: "Puja",
    //     catIcon: "puja.png",
    //     catLink: "/puja"
    // }
];

export default catData;